<template>
  <div>
    <div>
  <a-drawer
    :title="title"
    :maskClosable="false"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
    :z-index="2"
    style="height: 100%;overflow: auto;padding-bottom: 53px;">

    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right">
          <a-button @click="toggleScreen" icon="appstore" style="height:20px;width:20px;border:0px"></a-button>
        </span>
      </div>

    </template>

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules" >

        <a-form-model-item :label="language['user.column.userAccount']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="username" style="display: none">
          <a-input :placeholder="language['ad.must']+language['user.column.userAccount']" v-model="model.username" :disabled="disableSubmit"/><!---->
        </a-form-model-item>

        <a-form-model-item :label="language['user.column.userName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="realname">
          <a-input :placeholder="language['ad.must']+language['user.column.userName']" v-model="model.realname" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item :label="language['column.jobNumber']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="workNo">
          <a-input :placeholder="language['portal.front.please.number']" v-model="model.workNo" :disabled="disableSubmit"/>
        </a-form-model-item>

          <a-form-model-item :label="language['businessGroupName']"  :labelCol="labelCol" :wrapperCol="wrapperCol"  >
            <a-input v-model="emp.bg" type="text"  :placeholder="language['ad.must']+' '+language['businessGroupName']" :disabled="disableSubmit"/>
          </a-form-model-item>
          <a-form-model-item :label="language['businessUnitName']"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input v-model="emp.bu" type="text"  :placeholder="language['ad.must']+' '+language['businessUnitName']" :disabled="disableSubmit"/>
          </a-form-model-item>
        <a-form-model-item  :label="language['portal.personalOrgCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input v-model="emp.departName" type="text"  :placeholder="language['ad.must']+' '+language['portal.personalOrgCode']" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item :label="language['premission.applicationName']" prop="selectedApplications" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-multi-select-tag
            :disabled="disableSubmit"
            v-model="model.selectedApplications"
            :options="applicationOptions"
            placeholder="请选择应用">
          </j-multi-select-tag>
        </a-form-model-item>

        <a-form-model-item :label="language['column.userType']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <JDictSelectTag :type="'radio'" :disabled="disableSubmit"   v-model="model.userType" dictCode="protal_user_type"/>
        </a-form-model-item>
        <a-form-model-item :label="language['common.company']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.userType==='nonemployee'">
          <a-input :placeholder="language['common.pleaseInput']+language['common.company']" v-model="model.companyName" :maxLength="100" :disabled="disableSubmit"/>
        </a-form-model-item>
        <a-form-model-item :label="language['portal.personalOrgCode']" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-if="departIdShow==true">
          <j-multi-select-tag
            :disabled="disableSubmit"
            v-model="model.departIds"
            :options="nextDepartOptions"
            >
          </j-multi-select-tag>
        </a-form-model-item>



        <a-form-model-item :label="language['column.gender']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select  v-model="model.sex" :disabled="disableSubmit"  :getPopupContainer= "(target) => target.parentNode">
            <a-select-option :value="1">男</a-select-option>
            <a-select-option :value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="language['column.mailbox']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="email">
          <a-input :placeholder="language['ad.must']+language['column.mailbox']" v-model="model.email" :disabled="disableSubmit"/>
        </a-form-model-item>

        <a-form-model-item :label="language['column.cellphoneNumber']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="phone">
          <a-input :placeholder="language['ad.must']+language['column.cellphoneNumber']"  v-model="model.phone" :disabled="disableSubmit"/>
        </a-form-model-item>
        <a-divider type="horizontal" />
        <a-form-model-item :label="language['column.userRole']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="role"  v-if="roleLoading">
          <j-select-role-for-apply-check v-model="model.role" :disabled="disabledRole" :appId="this.appId" :option="rolesOptions"></j-select-role-for-apply-check>
        </a-form-model-item>
        <a-form-model-item :label="language['user.apply.project.organization']" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-if="roleLoading">
          <a-textarea :placeholder="language['ad.must']+language['user.apply.project.organization']" v-model="model.projectDepartNames" readonly="readonly"    style="width: 323px;"  />
          <a-button type="primary" icon="search"  @click="initDepart" style="margin-left: 8px">{{ language['common.selectButton'] }}</a-button>
        </a-form-model-item>
        <a-form-model-item :label="language['user.apply.review.comments']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="phone"  v-if="displayAuditRemark" >
          <a-textarea :placeholder="language['ad.must']+language['user.apply.review.comments']" v-model="model.auditRemark"  row="2"/>
        </a-form-model-item>

      </a-form-model>
    </a-spin>

    <div class="drawer-bootom-button" v-show="!auditFlag">
      <!--<a-popconfirm title="确定拒绝申请吗？" @confirm="reject" okText="确定" cancelText="取消">
        <a-button style="margin-right: .8rem">拒绝</a-button>
      </a-popconfirm>-->
      <a-button @click="close">{{ language['common.cancel'] }}</a-button>
      <a-popconfirm :title="language['common.submitConfirmInfo']" @confirm="goSubmit" :okText="language['common.submitButton']" :cancelText="language['common.cancel']">
        <a-button style="margin:0px 10px" type="primary">{{ language['common.submitButton'] }}</a-button>
      </a-popconfirm>
<!--      <a-button @click="pass" type="primary" :loading="confirmLoading">通过</a-button>-->
    </div>

  </a-drawer>
    </div>
      <div>
        <j-select-depart-modal-by-singleapplication ref="departSelectSingle" @ok="ok" ></j-select-depart-modal-by-singleapplication>
      </div>
  </div>


</template>

<script>
  import moment from 'moment'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getAction,httpAction,postAction } from '@/api/manage'
  import { queryall } from '@/api/api'
  import { disabledAuthFilter } from "@/utils/authFilter"
  import { duplicateCheck,applicationList } from '@/api/api'
  import JDictSelectTag from '@/components/dict/JDictSelectTag'

  import JSelectRoleForApplyCheck from '@/components/jeecgbiz/JSelectRoleForApplyCheck'
  import JSelectDepartModalBySingleapplication from '@/components/jeecgbiz/modal/JSelectDepartModalBySingleapplication'

  export default {
    name: "UserApplyAuditModal",
    components: {
      JDictSelectTag,JSelectRoleForApplyCheck,JSelectDepartModalBySingleapplication
    },
    props: {
      auditFlag: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        dialogStyle: {
          top: "30px"
        },
        submitType:"",
        roleLoading:false,
        modalVisible:false,
        disabledRole:false,
        displayAuditRemark:false,
        width:1200,
        selectedApplications:'',
        applicationOptions:[],
        departDisabled: false, //是否是我的部门调用该页面
        roleDisabled: false, //是否是角色维护调用该页面
        modalWidth:800,
        drawerWidth:700,
        modaltoggleFlag:true,
        confirmDirty: false,
        userId:"", //保存用户id
        appId:"", //保存appid
        appCode:"", //保存appCode
        id:"", //保存需要审核的主键id
        disableSubmit:false,
        dateFormat:"YYYY-MM-DD",
        departIdShow:false,
        title:"操作",
        visible: false,
        model: {},
        emp:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        uploadLoading:false,
        confirmLoading: false,
        headers:{},
        url: {
          userWithDepart: "/sys/user/userDepartList", // 引入为指定用户查看部门信息需要的url
          queryUserRoleList: '/sys/user/getUserRoleByApp',
          getUserDepartList: '/sys/user/getUserDepartList',
          audit: '/sys/sysUserApplicationApply/check/system',
          addUserMultipleRole:"/sys/sysUserApplicationApply/addUserMultipleRole",
          queryByWorkNo: '/sys/employee/queryByWorkNo',
        },
        tenantsOptions: [],
        rolesOptions:[],
        nextDepartOptions:[],
      }
    },
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      this.headers = {"X-Access-Token":token}
      this.initRoleList()
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
      validatorRules() {
        if (this.language) {
          return {
            role: [
              {required: true, message: ""},
            ]
          }
        }
      }
    },
    methods: {
      ok(data){
        let departIds="";
        let departNames="";
        let count=data.length
        data.forEach(function(element,index) {
         // console.log("element="+element+",index==="+index+",length:"+data.length);
          departIds+=element.id;
          departNames+=element.departName;
          if(index+1<count){
            departIds+=",";
            departNames+=",";
          }
        });
        this.model.projectDepartIds=departIds;
        this.model.projectDepartNames=departNames;
        //console.log("选择的部门id字符串=============:", this.model.projectDepartIds);
       // console.log("选择的部门名称=============:", this.model.projectDepartNames);
        this.$forceUpdate()
      },
      openModal(){
        this.modalVisible=true
      },
      goSubmit(){
        if(this.submitType=="chooseRole"){
          this.chooseRole();
        }else{
          this.audit();
        }
      },
      chooseRole () {
        if( this.model.role==""||typeof(this.model.role)=="undefined"){
          this.$message.error("至少选择一个角色再进行提交!");
          return;
        }

        const that = this
        that.confirmLoading = true
        let formData = {};

        formData.roleIds = this.model.role;
        formData.userId = this.userId;
        formData.appId = this.appId;
        formData.projectDepartIds=this.model.projectDepartIds;
        httpAction(that.url.addUserMultipleRole, formData, 'post').then((res) => {
          if (res.success) {
            that.$message.success(res.message)
            that.$emit('ok')
          } else {
            that.$message.warning(res.message)
          }
        }).finally(() => {
          that.confirmLoading = false
          that.close()
        })
      },

      audit () {
        // console.log("this.submitType:"+this.submitType+",this.model.role:"+this.model.role);
        // console.log("是否选择角色？？",this.submitType=="binding"&&this.model.role=="");
        if(this.submitType=="binding"&&(this.model.role==""||typeof(this.model.role)=="undefined")){
          this.$message.error(this.language['user.apply.warn.select.role']+"!");
          return;
        }
        const that = this
        that.confirmLoading = true
        let formData = {};

        formData.id=this.id;
        formData.roleIds = this.model.role;
        formData.userId = this.userId;
        formData.applicationId = this.appId;
        formData.auditRemark = this.model.auditRemark;
        formData.departIds = this.model.projectDepartIds;
        if(this.submitType=="binding"){
          formData.auditStatus="approved";
        }else{
          formData.auditStatus="rejected";
        }
        // alert(this.userId);
        // return ;
        console.log('表单提交数据', formData)
        postAction(that.url.audit, formData).then((res) => {
          if (res.success) {
            that.$message.success(res.message)
            that.$emit('ok')
          } else {
            that.$message.error(res.message)
          }
        }).finally(() => {
          that.confirmLoading = false
          that.close()
        })



      },
      edit (record,type) {
        console.log("record.bmApplication:",record.bmApplication)
        let that = this;
        that.visible = true;
        //根据屏幕宽度自适应抽屉宽度
        this.resetScreenSize();
       let user= record.sysUser;
        let app= record.bmApplication;
        that.userId = user.id;
        that.appId=app.id;
        that.appCode=app.applicationCode;
        that.model = Object.assign({},{selectedroles:'',selecteddeparts:''}, user);
        that.id=record.id;
       // that.model.role="07d7053e320811ec94d1005056a8603e";

        that.model.selectedApplications=app.id;


          //that.getUserRoles(user.id);
          that.getUserDeparts(user.id);
          that.initApplicationList();
          that.initUserRoleList();
        // if(type=='binding'||type=='chooseRole'){
        //   this.disabledRole=false;
        // }
        // if(type=='refuse'){
        //   this.disabledRole=true;
        //   this.displayAuditRemark="block";
        // }
        that.initEmpInfo(user.workNo);
        that.initProjectUserDepart();

        this.roleLoading=true;
        switch(type){
           case "chooseRole":
             this.disabledRole=false;
             this.displayAuditRemark=false;
             this.roleLoading=true;
             break;
          case "binding":
            this.disabledRole=false;
            this.displayAuditRemark=true;
            this.roleLoading=true;
            break;
          case "refuse":
            this.disabledRole=true;
            this.displayAuditRemark=true;
            this.roleLoading=false;
            break;
        }
          this.submitType=type;




      },
      isDisabledAuth(code){
        return disabledAuthFilter(code);
      },
      //窗口最大化切换
      toggleScreen(){
        if(this.modaltoggleFlag){
          this.modalWidth = window.innerWidth;
        }else{
          this.modalWidth = 800;
        }
        this.modaltoggleFlag = !this.modaltoggleFlag;
      },
      // 根据屏幕变化,设置抽屉尺寸
      resetScreenSize(){
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 500){
          this.drawerWidth = screenWidth;
        }else{
          this.drawerWidth = 700;
        }
      },
      initUserRoleList(){
        let param={};
        param.userId=this.userId;;
        param.appId=this.appId;

        getAction(this.url.queryUserRoleList,param).then(res=>{
          //一定要加这一个，值随便填。。上面用了display，不会显示这个值。，不然角色信息不能回显出来
          this.model.username='2'
          if(res.success){
            // this.model.role = res.result.map((item,index,arr)=>{
            //   let c = {label:item.roleName, value: item.id+""}
            //   return c;
            // })
            let str="";
            res.result.forEach(function(item,index,array){
              str+=item.id;
              if(index<res.result.length-1) {
                str += ",";
              }
            });
            this.model.role=str;
           // that.model.role="f6817f48af4fb3af11b9e8bf182f618b";

          }
        });
      },
      //初始化角色字典
      initRoleList(){
        queryall().then((res)=>{
          if(res.success){
            this.rolesOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.roleName, value:item.id}
              return c;
            })
           // console.log('this.rolesOptions: ',this.rolesOptions)
          }
        });
      },
      getUserDeparts(userid){
        let that = this;
        getAction(that.url.userWithDepart,{userId:userid}).then((res)=>{
          if(res.success){
            let departOptions=[];
            let selectDepartKeys=[]
            for (let i = 0; i < res.result.length; i++) {
              selectDepartKeys.push(res.result[i].key);
              //新增负责部门选择下拉框
              departOptions.push({
                value: res.result[i].key,
                label: res.result[i].title
              })
            }
            that.model.selecteddeparts = selectDepartKeys.join(",")
            that.nextDepartOptions=departOptions;
            console.log('that.nextDepartOptions=',that.nextDepartOptions)
          }
        })
      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selecteddeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      refresh () {
        this.userId=""
        this.nextDepartOptions=[];
        this.departIdShow=false;
      },
      close () {
        if(this.modalVisible){
          this.modalVisible=false
        }else{
          this.visible = false;
          this.roleLoading=false;
        }
        // this.$emit('close');
        // this.visible = false;
        // this.disableSubmit = false;
        // this.nextDepartOptions=[];
        // this.departIdShow=false;
        // this.$refs.form.resetFields();
      },
      moment,
      handleSubmit () {
        this.model.auditStatus = 'approved';
      },
      handleCancel () {
         this.close()
      },
      initApplicationList(){
        applicationList().then((res) => {
          if(res.success){
            this.applicationOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationNameLanguage||item.applicationName, value:item.id}
              return c;
            })
            console.log('this.applicationOptions: ',this.applicationOptions)
          }
        })
      },initEmpInfo(workNo){
        let params = {
          workNo: workNo
        };
        getAction(this.url.queryByWorkNo, params).then((res)=>{
          if (res.success) {
            console.log("=========员工信息=========",res);
            this.emp=res.result;
          }
        })

      },initDepart(){
        //初始化专案组织应用的部门信息
        console.log("this.appCode:",this.appCode)
        this.$refs.departSelectSingle.loadTree(this.appCode,this.model.projectDepartIds);
     },initProjectUserDepart(){
        //初始化专案组织组：用户，应用的部门信息
        let param={};
        param.userId=this.userId;;
        param.appId=this.appId;

        getAction(this.url.getUserDepartList,param).then(res=>{
          if(res.success){
            console.log(" res.result>>>", res.result);
            let departId="";
            let departNames="";
            res.result.forEach(function(item,index,array){
              departId+=item.id;
              departNames+=item.departName;
              if(index<res.result.length-1) {
                departId += ",";
                departNames += ",";
              }
            });
            this.model.projectDepartIds=departId;
            this.model.projectDepartNames=departNames;
            //console.log("初始化用户部门ids：", this.model.projectDepartIds)
           // console.log("初始化用户部门projectDepartNames：", this.model.projectDepartNames);
            //强制渲染。没有这个出不来
            this.$forceUpdate();
          }
        });
    }
    }
  }
</script>

<style scoped>
  .avatar-uploader > .ant-upload {
    width:104px;
    height:104px;
  }
  .ant-upload-select-picture-card i {
    font-size: 49px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }

  .drawer-bootom-button {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 40px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>